import { render, staticRenderFns } from "./AdvancedRevisionWizard.vue?vue&type=template&id=4e4559c4&scoped=true&"
import script from "./AdvancedRevisionWizard.vue?vue&type=script&lang=js&"
export * from "./AdvancedRevisionWizard.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedRevisionWizard.vue?vue&type=style&index=0&id=4e4559c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4559c4",
  null
  
)

export default component.exports